import { FeatureFlag } from '../FeatureFlag';

export const enableUpdateNotifier = new FeatureFlag<'enabled' | 'disabled' | 'immediate'>({
    key: 'show-update-notifications',
    defaultValue: 'disabled',
});
